import { getInjector } from '@Shared.Angular/flowingly.helper/serviceInjector';
import { SharedServiceTypeMap } from '@Shared.Angular/flowingly.hooks/useService';

/**
 * Hook to get angularJs service via injector
 * @typedef T - type of the service
 * @param name
 * @returns T - the angularJs service
 * @deprecated Use `getService` instead.
 */
export const useService = <T>(name: RunnerServiceName): T =>
  getInjector().get(name) as T;

type ServiceTypeMap = SharedServiceTypeMap & {
  runnerStartFlowsFormatter: RunnerStartFlowsFormatter;
  flowListManager: FlowListManager;
  flowTodoService: FlowTodoService;
  runnerCategoryNavigationService: RunnerCategoryNavigationService;
  proceduresService: ProceduresService;
  runnerPublicMapApiService: RunnerPublicMapApiService;
};

export const getService = <K extends RunnerServiceName>(
  name: K
): ServiceTypeMap[K] => getInjector().get(name) as ServiceTypeMap[K];
